<template>
    <div class="container-fluid">
        <div class="mt-2">
            <label>Course Certificate Copy Id</label>
            <select @change="$emit('updatePreview')" v-model="courseDetails.certificateCourseCopyId">
                <option :value="null">N/A</option>
                <option v-for="course in courses" :value="course.id">{{course.id}} - {{course.name}}</option>
            </select>
        </div>
        <div class="mt-3">
            <label>Orientation</label>
            <select @change="$emit('updatePreview')" v-model="courseDetails.certificateOrientation">
                <option value="Portrait">Portrait</option>
                <option value="Landscape">Landscape</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CertificateFields",
        props: ['edit', 'initialCourseDetails', 'initialCourses'],
        data() {
            return {
                editEnabled: this.edit,
                courseDetails: this.initialCourseDetails,
                courses: this.initialCourses
            }
        },
        watch: {
            edit: function (newVal, oldVal) {
                this.editEnabled = newVal;
            },
            initialCourseDetails: function (newVal, oldVal) {
                this.courseDetails = newVal;
            },
            initialCourses: function (newVal, oldVal) {
                this.courses = newVal;
            },
        },
        mounted() {
            //console.log("Certificate fields loaded");
            if(!this.courseDetails.certificateCourseCopyId){
                this.courseDetails.certificateCourseCopyId = null;
            }
        }
    }
</script>